var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.01 18.5a1 1 0 00-1 1v.5a.5.5 0 01-.5.5h-5.5a.5.5 0 01-.51-.5V4a.5.5 0 01.5-.5h5.5a.5.5 0 01.5.5v1a1 1 0 002 0V2.5a1 1 0 00-1-1h-7.5v-1a.51.51 0 00-.18-.39A.53.53 0 009.9 0l-9 2a.5.5 0 00-.4.5v19a.5.5 0 00.4.5l9 2a.51.51 0 00.6-.5v-1H18a1 1 0 001-1v-2a1 1 0 00-.99-1zm-10-6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: "#002147"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.99 11h-4.12V9.25a1 1 0 00-.53-.88 1 1 0 00-1 .05l-4.87 3.25a1 1 0 000 1.66l4.87 3.25a1 1 0 001.56-.83V14h4.12a1.5 1.5 0 100-3h-.03z",
    fill: "#002147"
  })));
}
export default SvgIconSignOut;